export const error = state => state.error
export const isLoading = state => state.isLoading
export const violations = state => state.violations
export const updated = state => state.updated
export const expiredToken = state => state.expiredToken
export const invalidToken = state => state.invalidToken
